import { render, staticRenderFns } from "./MapCities.vue?vue&type=template&id=4bafc4ef&"
import script from "./MapCities.vue?vue&type=script&lang=js&"
export * from "./MapCities.vue?vue&type=script&lang=js&"
import style0 from "./MapCities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports